import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import ScrollToTop from '../components/common/ScrollToTop';
import Home from '../pages/Home';
import About from '../pages/About';
import Deposits from '../pages/Deposits';
import Loans from '../pages/Loans';
import FinancialInfo from '../pages/FinancialInfo';

import FuturePlans from '../pages/FuturePlans';
import Media from '../pages/Media';
import Careers from '../pages/Careers';
import Contact from '../pages/Contact';

const AppRoutes = () => {
    return (
        <Router>
            <ScrollToTop />
            <div className="app">
                <Navbar />
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/deposits" element={<Deposits />} />
                        <Route path="/loans" element={<Loans />} />
                        <Route path="/financial-info" element={<FinancialInfo />} />

                        <Route path="/future-plans" element={<FuturePlans />} />
                        <Route path="/media" element={<Media />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
};

export default AppRoutes;
